import { DownloadCSVDoc } from "./FileDownloadManager";
import {
  handleInputChangeDate,
  handleSubmitChangeInstance,
} from "./handlers";
import { faSearch, faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { handleCopy } from "./CopyDocID";
import { CopyToClipboard } from "react-copy-to-clipboard";
import React from "react";
import { parseRemiseDate, formatCustomDate } from "./DateManager";
import DatePicker from "react-datepicker";
import Cookies from "js-cookie";
import "../Dashboard/Default/TabLots/LotsTable.css";

export const renderDataCellLots = (item, col, context, idx) => {
  const value = item[col.key];
  const role = Cookies.get("Role");

  switch (col.DataType) {
    case "actions":
      if (role == "user"){
        return (
          <td key={`actions-${idx}`} className="style_tbody_td">
            <DownloadCSVDoc item={item} />
            <button
              className="btn btn-sm"
              data-toggle="tooltip"
              title={context.t("View instance")}
              onClick={() => {
                Cookies.set("modelId", item.sModelId);
                Cookies.set("instanceId", item.kInstanceId);
                Cookies.set("instanceName", item.sInstanceName);
                Cookies.set("instanceStatus", item.sStatus);
                context.navigate(`/User/${getDocsKeyFromModelId(item.sModelId)}`);
              }}
            >
              <FontAwesomeIcon icon={faSearch} />
            </button>
          </td>
        );
      } else if (role == "superadmin"){
        return (
          <td key={`actions-${idx}`} className="style_tbody_td">
            <DownloadCSVDoc item={item} />
            <button
              className="btn btn-sm"
              data-toggle="tooltip"
              title={context.t("View instance")}
              onClick={() => {
                Cookies.set("modelId", item.sModelId);
                Cookies.set("instanceId", item.kInstanceId);
                Cookies.set("instanceName", item.sInstanceName);
                Cookies.set("instanceStatus", item.sStatus);
                Cookies.set("clientId", item.kClientId);
                // Cookies.set("")
                context.navigate(`/Admin/AdmDocsTable`);
              }}
            >
              <FontAwesomeIcon icon={faSearch} />
            </button>
          </td>
        )
      }
    case "datepicker":
      return (
        <td
          key={`datepicker-${idx}`}
          className="style_remise_date"
        >
          <DatePicker
            selected={parseRemiseDate(value)}
            className="select_editable_style"
            onChange={(date) =>
              handleInputChangeDate(
                date,
                item.kInstanceId,
                col.key,
                context.data,
                context.setData,
                handleSubmitChangeInstance
              )
            }
            dateFormat="dd/MM/yyyy"
          />
        </td>
      );

    case "date":
      return (
        <td key={`date-${idx}`} style={{ lineHeight: "1" }}>
          {formatCustomDate(item.dCreationDate)}
        </td>
      );

    case "instanceName":
      return (
        <React.Fragment key={`instanceName-${idx}`}>
          <td style={{ fontWeight: col.bold ? "bold" : "normal", width : "250px" }}>{value}</td>
          <td style={{width : "50px"}}>
            <CopyToClipboard
              text={item.kInstanceId}
              onCopy={() => handleCopy(item.kInstanceId)}
            >
              <button
                className="btn btn-sm"
                data-toggle="tooltip"
                title="Copy instanceId"
              >
                <FontAwesomeIcon icon={faCopy} />
              </button>
            </CopyToClipboard>
          </td>
        </React.Fragment>
      );
    case "select-editable":
      return (
        <td key={`status-${idx}`} style={{ width: "100px" }}>
          {Array.isArray(context.modelInstanceStatuses) &&
          context.modelInstanceStatuses.length > 1 ? (
            <select
              className="form-control select_editable_style"
              style={{ fontSize: "12px", height: "auto" }}
              value={item.sStatus || ""}
              onChange={(e) =>
                handleInputChangeDate(
                  e.target.value,
                  item.kInstanceId,
                  "sStatus",
                  context.data,
                  context.setData,
                  handleSubmitChangeInstance
                )
              }
            >
              <option value={item.sStatus}>{item.sStatus}</option>
              {context.modelInstanceStatuses.map((status, index) => (
                <option key={`status-opt-${index}`} value={status}>
                  {status}
                </option>
              ))}
            </select>
          ) : (
            <span>{context.modelInstanceStatuses?.[0] || "-"}</span>
          )}
        </td>
      );

    default:
      return (
        <td
          key={`default-${idx}`}
          style={{ fontWeight: col.bold ? "bold" : "normal" }}
        >
          {value}
        </td>
      );
  }
};

const getDocsKeyFromModelId = (modelId) => {
  if (!modelId) return "";
  const parts = modelId.split("-");
  const last = parts[parts.length - 1];
  return last.charAt(0).toUpperCase() + last.slice(1) + "Docs";
};
